const formatDate = (datetime: string) => {
  const datetimeSplited: string[] = datetime.split('T');
  const dateSplited: string[] = datetimeSplited[0].split('-');

  return `${dateSplited[1]}-${dateSplited[2]}-${dateSplited[0]}`;
};

export default formatDate;
